import styled, { Scale } from '@secretescapes/falcon';

export const Container = styled('div')`
  position: fixed;
  bottom: 0px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${Scale.m};
  padding: ${Scale.m};
  background: ${({ theme }) => theme.color.white};
  border-top: ${({ theme }) => `${theme.color.grey10} 1px solid`};
  box-shadow: 0px -1px 2px 0px rgba(0, 0, 0, 0.25);
`;

export const Summary = styled('div')`
  display: flex;
  gap: ${Scale.m};
`;
